/**
 * Initialize Facebook SDK
 * Handles both async load and existing script scenarios.
 * @param {Object} options - FB.init options
 */
export const initFacebookSdk = (options = {}) => {
    const getEnv = (key) => {
        return (window._env_ && window._env_[key]) || process.env[key];
    };

    const defaultOptions = {
        appId: getEnv('REACT_APP_FB_ID') || '1173925589672927',
        cookie: true,
        xfbml: true,
        version: 'v5.0'
    };

    const finalOptions = {
        ...defaultOptions,
        ...options
    };

    const init = () => {
         if (window.FB) {
            window.FB.init(finalOptions);
        }
    };

    console.log(`initFacebookSdk with appId: ${finalOptions.appId}`)

    if (window.FB) {
        init();
    } else {
        window.fbAsyncInit = init;
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }
};
